// City dropdown data for the lead form.
// Built at module load time from the same CITY_COORDS dataset used by the globe,
// so the two stay in sync without duplication.
import CITY_COORDS from "./usCityCoords";

function titleCase(str) {
    return str.replace(/(^|[\s-])(\S)/g, (_, sep, char) => sep + char.toUpperCase());
}

// Keyed by uppercase state abbreviation ("NC", "TX", …) → sorted city name array.
export const CITIES_BY_STATE = {};
for (const key of Object.keys(CITY_COORDS)) {
    const sep = key.indexOf("||");
    if (sep === -1) continue;
    const city  = titleCase(key.slice(0, sep));
    const state = key.slice(sep + 2).toUpperCase();
    if (!CITIES_BY_STATE[state]) CITIES_BY_STATE[state] = [];
    CITIES_BY_STATE[state].push(city);
}
for (const state of Object.keys(CITIES_BY_STATE)) {
    CITIES_BY_STATE[state].sort();
}

// Case-insensitive city match against the known list for a state.
// Returns the properly-cased name if found, the trimmed original otherwise.
export function normalizeCityField(city, stateAbbr) {
    if (!city || !stateAbbr) return city || "";
    const cities = CITIES_BY_STATE[stateAbbr.toUpperCase()] || [];
    const match  = cities.find(c => c.toLowerCase() === city.trim().toLowerCase());
    return match || city.trim();
}
